import { transformAsCurrency } from '~/utils/functions';

interface ComposicaoItem {
  val_venda: number | string;
  val_venda_composicao: number | string;
  qtd_composicao: number | string;
}

interface Totais {
  totalLoja: number;
  totalComposicao: number;
}

export function calcularTotais(items: ComposicaoItem[]): Totais {
  return items.reduce(
    (acc, item) => {
      const valVenda = transformAsCurrency(item.val_venda) || 0;
      const valVendaComposicao =
        transformAsCurrency(item.val_venda_composicao) || 0;
      const qtd = transformAsCurrency(item.qtd_composicao) || 0;

      acc.totalLoja += valVenda * qtd;
      acc.totalComposicao += valVendaComposicao * qtd;
      return acc;
    },
    { totalLoja: 0, totalComposicao: 0 },
  );
}
